<ccc-cca-loading-spinner [show]="isLoading"></ccc-cca-loading-spinner>

<div class="container-fluid">
  <ccc-table [config]="licensesTableConfig"
             (sortField)="onSort($event)"
             (functionEmitted)="onFunctionEmitted($event)"
             (pageChanged)="onPageChange($event)">
    <tbody>
      <ng-container *ngFor="let license of licenses">
        <tr class="text-center" *ngIf="license.id !== editingElement?.id">
          <td>{{license.docType}}</td>
          <td>{{license.orderRef}}</td>
          <td>{{license.orgName}}</td>
          <td>{{license.startDate | date:'shortDate':'UTC'}}</td>
          <td>{{license.endDate | date:'shortDate':'UTC'}}</td>
          <td>{{license.externalProductId}}</td>
          <td>{{license.purchasedSeats}}</td>
          <td>{{license.licenseKey}}</td>
          <td>{{license.notes}}</td>
          <td>
            <label class="edit-license-btn" (click)="editLicense(license)" *ngIf="!isEditing && !isCreating">
              edit
            </label>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </ccc-table>
  <ngb-alert type="warning"
             class="empty-list"
             *ngIf="!isLoading && !licenses.length"
             [dismissible]="false">
    No licenses available on {{organizationName}}
  </ngb-alert>
</div>

<ccc-cca-licenses-modal #licenseModal
                        [organizationId]="organizationId"
                        [licensesType]="licensesType"
                        [programProdCodes]="programProdCodes"
                        (updateLicenses)="onUpdateLicenses($event)">
</ccc-cca-licenses-modal>
